import React from 'react';

export default function SectionHeader({ eyebrow, title, subtitle, center = false, light = true, maxWidth = '560px' }) {
  return (
    <div style={{ textAlign: center ? 'center' : 'left', marginBottom: '3.5rem' }}>
      {eyebrow && (
        <div style={{ display: center ? 'flex' : 'block', justifyContent: center ? 'center' : 'flex-start', marginBottom: '1rem' }}>
          <span className="tag-label">{eyebrow}</span>
        </div>
      )}
      <h2 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(2rem, 4vw, 3rem)',
        fontWeight:600,
        lineHeight: 1.1,
        color: light ? '#f8f5ef' : '#0c0c0c',
        maxWidth: center ? maxWidth : 'none',
        margin: center ? '0 auto' : '0',
        letterSpacing: '-0.01em',
      }}>
        {title}
      </h2>
      <div className={`gold-line${center ? ' center' : ''}`} style={{ marginTop: '1.25rem' }} />
      {subtitle && (
        <p style={{
          color: light ? '#8a8278' : '#555',
          fontSize: '0.9rem',
          lineHeight: '1.85',
          maxWidth: center ? maxWidth : '520px',
          margin: center ? '0 auto' : '0',
        }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
